
import React from 'react';
import { motion } from 'framer-motion';
import SupportTabs from '../components/SupportTabs';

const qnaData = [
    { id: 1, title: '배연창 설치 견적 문의드립니다.', writer: '김철수', date: '2025-01-02', status: '답변완료' },
    { id: 2, title: 'AS 신청 방법 문의', writer: '이영희', date: '2025-01-01', status: '답변대기' },
    { id: 3, title: '제품 카탈로그 요청', writer: '박민수', date: '2024-12-28', status: '답변완료' },
    { id: 4, title: '환기창 작동 불량 문의', writer: '정수진', date: '2024-12-25', status: '답변완료' },
    { id: 5, title: '대량 구매 시 할인율이 어떻게 되나요?', writer: '최동훈', date: '2024-12-20', status: '답변대기' },
];

function Qna() {
    return (
        <div className="text-gray-800">
            {/* Hero Section */}
            <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
                <div className="absolute inset-0 bg-black bg-opacity-50" />
                <div className="relative z-10 text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white">고객지원</h1>
                    <p className="mt-4 text-white text-lg md:text-xl">
                        고객님의 궁금한 점을 해결해 드립니다.
                    </p>
                </div>
                {/* Support Tabs */}
                <SupportTabs />
            </section>

            {/* Bulletin Board Section */}
            <section className="py-16 px-6 md:px-20 max-w-6xl mx-auto">
                <div className="flex justify-between items-end mb-4 border-b pb-4 border-gray-300">
                    <h2 className="text-2xl font-bold text-gray-800">Q&A</h2>
                    <span className="text-sm text-gray-500">총 {qnaData.length}건</span>
                </div>

                {/* Table / List */}
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-gray-100 text-gray-700 border-b border-gray-300">
                                <th className="p-4 w-16 text-center font-semibold">No.</th>
                                <th className="p-4 w-24 text-center font-semibold">상태</th>
                                <th className="p-4 font-semibold">제목</th>
                                <th className="p-4 w-32 text-center font-semibold">작성자</th>
                                <th className="p-4 w-32 text-center font-semibold">작성일</th>
                            </tr>
                        </thead>
                        <tbody>
                            {qnaData.map((item, index) => (
                                <motion.tr
                                    key={item.id}
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3, delay: index * 0.1 }}
                                    viewport={{ once: true }}
                                    className="border-b border-gray-200 hover:bg-gray-50 transition-colors"
                                >
                                    <td className="p-4 text-center text-gray-500">{qnaData.length - index}</td>
                                    <td className="p-4 text-center">
                                        <span className={`px-2 py-1 text-xs font-bold rounded-full ${item.status === '답변완료'
                                                ? 'bg-blue-100 text-blue-800'
                                                : 'bg-gray-200 text-gray-600'
                                            }`}>
                                            {item.status}
                                        </span>
                                    </td>
                                    <td className="p-4 font-medium text-gray-800 cursor-pointer hover:underline">{item.title}</td>
                                    <td className="p-4 text-center text-gray-600">{item.writer}</td>
                                    <td className="p-4 text-center text-gray-500">{item.date}</td>
                                </motion.tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}

export default Qna;
